"use strict";
var hi = "Hi";
module.exports = {
  hi: hi,
};
